<template>
  <div>
    <h2 class="mobile-page-title">Add/View Maintenance Logs</h2>
    <form class='md-layout file-upload-form' @submit='submit($event)'>
    <md-field>
      <label>Upload Maintenance Information</label>
      <md-file @change="cool($event.target.files)"></md-file>
    </md-field>
    <md-field class="md-has-file">
      <label>Title</label>
      <md-icon>title</md-icon>
      <md-input v-model='title' />
    </md-field>
    <md-field class="md-has-file">
      <label>Further description</label>
      <md-icon>description</md-icon>
      <md-input v-model='description' />
    </md-field>
    <md-button type='submit' class="md-success md-sm">Upload</md-button>
    </form>
    <div class="gpr-info files" v-for="file in files" :key="file.id">
      <div class="file-info">
        <h6><a :href="file.url">{{file.fileName}}</a></h6>
	<p>Title: {{file.title}}</p>
        <p>Description: {{file.description}}</p>
        <p>Posted By: {{file.userName}}</p>
        <p>{{file.createdAt}}</p>
      </div>
    </div>
  </div>
</template>
<script>
  import api from '../../../../api';
  export default {
    data() {
      return {
        files: [],
        description: '',
	newFile: null
      }
    },
    methods: {
      cool(files) {
	this.newFile = files;
      },
      submit(e) {
	e.preventDefault();
        var formData = new FormData();
        formData.append('file', this.newFile[0]);
        formData.append('description', this.description);
        formData.append('title', this.title);
	console.log('we here');
        api.createLogItem(this.project.project.id, formData)
          .then(a => {
	    console.log(a);
            this.files = [...this.files, a.data.log_item];
            this.newFile = null;
            this.description = '';
            this.title = '';
          })
      }
    },
    created() {
      api.getMaintenanceLogs(this.project.project.id)
        .then( ml => {
	  this.files = ml.data.logItems.filter(m => m)
	});
    },
    props: {
      project: {
        type: Object
      }
    }
  }
</script>
<style lang="scss">

</style>
